module.exports = __webpack_public_path__ + "static/GNT3-05a20240e2c194895a00bd89357ab632.png";